// Before `identify()`, Mixpanel uses the device id as the distinct id, either
// as is or prefixed with `$device:`. Any other distinct id belongs to a user
// who signed in on this device.
export const checkIsAnonymousMixpanelId = ({
  distinctId,
  deviceId,
}: {
  distinctId: string | null | undefined;
  deviceId: string | null | undefined;
}) =>
  Boolean(deviceId) &&
  (distinctId === deviceId || distinctId === `$device:${deviceId}`);
